export default __webpack_public_path__ + "static/safer_technologies_for_schools_badge-4b12d631910051f01ba742e5cbfa1acc.png";